import { staffHome } from '../utils/reflectStaff';
import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processAuthCode, setUser, setIsAuthenticated } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleAuth = async () => {
      // Google returns ?code=...&state=... as query params, not a hash fragment
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      // redirect_to (for cross-app SSO, e.g., Beat Arranger) is carried in Google's `state` param
      const redirectTo = params.get('state') ? decodeURIComponent(params.get('state')) : null;

      if (code) {
        // Must exactly match the redirect_uri used in the original authorize request
        const redirectUri = window.location.origin + '/admin';

        try {
          const userData = await processAuthCode(code, redirectUri);
          setUser(userData);
          setIsAuthenticated(true);
          
          // If redirect_to is specified and is a valid letthebeatbuild.me subdomain, redirect there
          if (redirectTo) {
            try {
              const redirectUrl = new URL(redirectTo);
              // Only allow redirects to letthebeatbuild.me subdomains for security
              if (redirectUrl.hostname.endsWith('.letthebeatbuild.me') || 
                  redirectUrl.hostname === 'letthebeatbuild.me') {
                window.location.href = redirectTo;
                return;
              }
            } catch (e) {
              console.warn('Invalid redirect_to URL:', redirectTo);
            }
          }
          
          // Admins land on the dashboard, teachers and counselors on Reflect,
          // everyone else on the library.
          navigate(staffHome(userData), {
            replace: true,
            state: { user: userData }
          });
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/admin/login', { replace: true });
        }
      } else {
        navigate('/admin/login', { replace: true });
      }
    };
    
    handleAuth();
  }, [location, navigate, processAuthCode, setUser, setIsAuthenticated]);
  
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
